import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { IIngredientListParameters } from "../../sdk/utils/api/ingredients";

export const useGetIngredients = (
    queryKey: string | (string | number)[],
    parameters: IIngredientListParameters,
    options?: { enabled?: boolean; keepPreviousData?: boolean },
): UseQueryResult<types.IOffsetPage<types.IIngredient>> => {
    const auth = useAuth();

    return useQuery<types.IOffsetPage<types.IIngredient>>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch without authorization token.");
            }
            return await api.Ingredients.list(parameters, auth.token);
        },
        options,
    );
};
